export default function CloudTaskIcon({
  ...props
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        fill="fill-current opacity-40"
        d="m16 17.143-1.666-.952v1.806a.333.333 0 0 0 .166.29l1.5.857v-2Z"
      />
      <path
        fill="currentColor"
        d="m9.836 5.759-1.5.857 1.664.95 1.667-.95-1.5-.857a.333.333 0 0 0-.331 0Z"
      />
      <path
        fill="fill-current opacity-40"
        d="M5.667 17.997v-1.806L4 17.143v2l1.5-.857a.333.333 0 0 0 .167-.289ZM8 8.996a.333.333 0 0 0 .167.29l1.5.857v-2L8 7.191v1.805Z"
      />
      <path
        fill="currentColor"
        d="m3.666 16.568 1.665-.975-1.498-.88a.326.326 0 0 0-.33 0l-1.5.88 1.663.975Z"
      />
      <path
        fill="fill-current opacity-40"
        d="m1.833 18.286 1.5.858v-2l-1.667-.953v1.806a.334.334 0 0 0 .167.29Z"
      />
      <path
        fill="currentColor"
        d="m11.665 15.592-1.498-.879a.326.326 0 0 0-.331 0l-1.5.88 1.664.975 1.665-.976Z"
      />
      <path
        fill="fill-current opacity-40"
        d="m16.666 19.143 1.5-.856a.333.333 0 0 0 .167-.29v-1.806l-1.666.952v2Z"
      />
      <path
        fill="currentColor"
        d="m17.998 15.592-1.498-.879a.326.326 0 0 0-.33 0l-1.5.88 1.663.975 1.665-.976ZM6.625 4.001a.328.328 0 0 1-.162-.042 2.338 2.338 0 0 0-2.012-.116 2.333 2.333 0 0 0 .882 4.492h2V6.81a.672.672 0 0 1 .334-.578l2-1.145a.687.687 0 0 1 .659-.003l2.007 1.146a.673.673 0 0 1 .334.58v1.524h2a2.333 2.333 0 1 0-1.458-4.155.333.333 0 0 1-.54-.297.334.334 0 0 1 .122-.223 3.005 3.005 0 0 1 1.503-.634 1.327 1.327 0 0 0-2.053-.786c-.002 0-.005 0-.007.003-.2.14-.358.334-.457.558a.334.334 0 0 1-.61-.266 2 2 0 0 1 .427-.618 3.323 3.323 0 0 0-5.782 1.125c.342.054.672.167.975.334A.333.333 0 0 1 6.625 4Z"
      />
      <path
        fill="currentColor"
        d="M12 17.997v-1.806l-1.666.952v2l1.5-.857a.333.333 0 0 0 .166-.289ZM11.834 9.287a.334.334 0 0 0 .166-.29V7.191l-1.666.952v2l1.5-.856ZM8 17.996a.333.333 0 0 0 .167.29l1.5.857v-2L8 16.191v1.805ZM16.66 14.084l.007.003v-1.086a1.003 1.003 0 0 0-1-1h-5.333v-1.087a.71.71 0 0 1-.334.087.662.662 0 0 1-.326-.084l-.007-.003v1.087H4.334a1.003 1.003 0 0 0-1 1v1.086a.692.692 0 0 1 .66-.003l.006.003v-1.086a.333.333 0 0 1 .333-.334h5.334v1.42a.692.692 0 0 1 .66-.003l.007.003v-1.42h5.333a.333.333 0 0 1 .333.334v1.086a.692.692 0 0 1 .66-.003Z"
        opacity={0.4}
      />
    </svg>
  );
}
